import {SCROLL_DOWN, SCROLL_UP} from "../actions/PanelScroll";
import ScrollDirection from "../core/constants/ScrollDirection";

const initialState = {
    direction: ScrollDirection.UP
};


const panelScrollReducer = (state = initialState, action) => {
    switch (action.type) {
        case SCROLL_DOWN:
            return {
                direction: action.payload.direction
            };
        case SCROLL_UP:
            return {
                direction: action.payload.direction
            };
        default:
            return state
    }
};


export default panelScrollReducer;
